import keyMirror from 'react-utils/keyMirror';
export let TemplateNames;
(function (TemplateNames) {
  TemplateNames["BLANK"] = "BLANK";
  TemplateNames["FEEDBACK"] = "FEEDBACK";
  TemplateNames["PAYMENT"] = "PAYMENT";
  TemplateNames["NEWSLETTER"] = "NEWSLETTER";
  TemplateNames["WEBINAR"] = "WEBINAR";
  TemplateNames["CONTACT_US"] = "CONTACT_US";
  TemplateNames["EBOOK"] = "EBOOK";
  TemplateNames["SUPPORT"] = "SUPPORT";
  TemplateNames["REGISTRATION"] = "REGISTRATION";
})(TemplateNames || (TemplateNames = {}));
export const IllustrationsMap = {
  [TemplateNames.BLANK]: 'plus',
  [TemplateNames.REGISTRATION]: 'registration',
  [TemplateNames.CONTACT_US]: 'transactional-email-envelope',
  [TemplateNames.NEWSLETTER]: 'registration',
  [TemplateNames.PAYMENT]: 'payments-button',
  [TemplateNames.SUPPORT]: 'customer-support',
  [TemplateNames.EBOOK]: 'ebook-download',
  [TemplateNames.WEBINAR]: 'event-registration',
  [TemplateNames.FEEDBACK]: 'idea'
};
export const FeedbackOptions = keyMirror({
  conferenceRegistration: null,
  leadGeneration: null,
  jobApplication: null,
  webinarRegistration: null
});